import {Route,Switch,BrowserRouter } from "react-router-dom";

import DoobiHeader from "components/Headers/DoobiHeader";
import BannersTable from "components/Doobi/Banners";

const BannersRoute = ({ match }) => {
  return (
    <>
  <DoobiHeader section="Banners" />
    <BrowserRouter>
    <Switch>
      <Route path={`${match.path}/`} component={BannersTable}/>
    </Switch>
    </BrowserRouter>
    </>
    );
  }; 


export default BannersRoute;
